import type { SVGProps } from 'react';
const SvgPanoramaWideAngleSelect = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#panorama_wide_angle_select_svg__a)">
      <path
        fill="currentColor"
        d="M12 4c-2.73 0-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12c0 2.07.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73 2.73 0 5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23 0-2.07-.29-4.15-.87-6.22l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4Z"
      />
    </g>
    <defs>
      <clipPath id="panorama_wide_angle_select_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPanoramaWideAngleSelect;
